import React from "react";
import { Loader2 } from "lucide-react";

const ConfiguringAuthStep: React.FC = () => {
  return (
    <div className="space-y-4">
      <div className="flex flex-col items-center gap-4 py-16">
        <Loader2 className="w-8 h-8 animate-spin text-primary-n-500" />
        <div className="text-sm text-secondary-n-300 text-center">
          Configuring authentication
          <span className="inline-flex gap-0.5 ml-1">
            <span
              className="w-1 h-1 bg-current rounded-full animate-pulse"
              style={{ animationDelay: "0s", animationDuration: "1.2s" }}
            ></span>
            <span
              className="w-1 h-1 bg-current rounded-full animate-pulse"
              style={{
                animationDelay: "0.4s",
                animationDuration: "1.2s",
              }}
            ></span>
            <span
              className="w-1 h-1 bg-current rounded-full animate-pulse"
              style={{
                animationDelay: "0.8s",
                animationDuration: "1.2s",
              }}
            ></span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default ConfiguringAuthStep;
